import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { CREATE_USER_MUTATION } from '../graphql/mutations'
import { transformToSaveUserArgs } from '../graphql/transformers'
import { UPSERT_USER_DETAILS } from '../redux/action-types'

const useCreateUserMutation = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.users.user)

  const mutate = useCallback(
    userData =>
      apolloService.mutate(
        CREATE_USER_MUTATION,
        { data: transformToSaveUserArgs(userData) },
        dispatch,
        UPSERT_USER_DETAILS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useCreateUserMutation
